import { TrackerChart } from "../../../Wellbeing/components/Trackers/Charts/TrackerChart";
import { ChartDayOffsets } from "../../../Wellbeing/components/Trackers/Charts/helpers";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MoodTrackerWellbeingId } from "UIPalette/MoodTrackerCard/MoodTrackerCard";
import { yAxisMoodImagePlugin } from "./yAxisMoodImagePlugin";
import { useGetMoodStatFunctionRequest, UserTrackerValue } from "shared/request/myHealthyAdvantageApi";
import { ClientInfoState } from "shared/core/state/clientInfoState";
import { useMoodTrackerContext } from "core/state/Trackers/MoodTrackerContext";

export const MoodChart = () => {
  const clientCode = ClientInfoState.getCode();
  const today = new Date();
  const { t } = useTranslation();
  const [dateFrom, setDateFrom] = useState<Date>(today.addDays(ChartDayOffsets.week));
  const {
    data: moodStats,
    isLoading,
    error,
    mutate,
  } = useGetMoodStatFunctionRequest({ xClientCode: clientCode, from: dateFrom.toDateOnlyString(), to: today.toDateOnlyString() });

  const { triggerMutate, resetTriggerMutate } = useMoodTrackerContext();

  useEffect(() => {
    const handleRefresh = async () => {
      await mutate();
      resetTriggerMutate();
    };

    if (triggerMutate) {
      handleRefresh();
    }
  }, [mutate, resetTriggerMutate, triggerMutate]);

  const moodChartData: UserTrackerValue[] | undefined = moodStats?.moods.map((mood) => ({
    date: new Date(mood.createdDateUtc).toDateOnly(),
    value: mood.mood,
  }));

  return (
    <div id={MoodTrackerWellbeingId}>
      <TrackerChart
        trackerType={"Mood"}
        heading={t("wellbeing.moodChart.heading")}
        yAxisStepSize={1}
        yAxisMax={5.5}
        loading={isLoading}
        showError={!!error}
        showYAxisTick={false}
        data={moodChartData ?? []}
        dateRange={{ startDate: dateFrom, endDate: today }}
        reload={() => mutate()}
        onChartViewOffsetChange={(offset) => setDateFrom(today.addDays(offset))}
        initialChartViewOffset={ChartDayOffsets.week}
        plugins={[yAxisMoodImagePlugin]}
      />
    </div>
  );
};
